/*
 * iurop-cart-confirm.js — sección "Confirmar carrito".
 *  - Repinta la sección tras cualquier cambio de carrito (evento `cart:updated`)
 *    usando Section Rendering sobre la propia página: el markup vive solo en Liquid.
 *  - Botones − / + por línea: /cart/change.js y después `cart:updated`, que
 *    también refresca el drawer y el contador del header. Bajar de 1 quita la línea.
 */
(function () {
  var pending = null;
  var busy = false;

  function changeUrl() {
    var base = (window.routes && window.routes.cart_change_url) || '/cart/change';
    return base.replace(/\.js$/, '') + '.js';
  }

  function refresh() {
    var roots = document.querySelectorAll('[data-cart-confirm-root]');
    if (!roots.length) return Promise.resolve();
    return Promise.all(Array.prototype.map.call(roots, function (root) {
      var id = root.getAttribute('data-section-id');
      var url = window.location.pathname + '?section_id=' + encodeURIComponent(id) + '&_=' + Date.now();
      return fetch(url, { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-cart-confirm-root]');
          if (fresh) root.innerHTML = fresh.innerHTML;
        })
        .catch(function () {});
    }));
  }

  document.addEventListener('cart:updated', function () {
    clearTimeout(pending);
    pending = setTimeout(refresh, 150);
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cc-step]');
    if (!btn || busy) return;
    var root = btn.closest('[data-cart-confirm-root]');
    if (!root) return;

    var qty = Math.max(0, (parseInt(btn.getAttribute('data-qty'), 10) || 0) + parseInt(btn.getAttribute('data-cc-step'), 10));
    var card = root.querySelector('.ig-cart-confirm__card');
    busy = true;
    if (card) card.classList.add('is-busy');
    root.querySelectorAll('[data-cc-step]').forEach(function (b) { b.disabled = true; });

    fetch(changeUrl(), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: btn.getAttribute('data-key'), quantity: qty })
    })
      .then(function (r) { if (!r.ok) throw new Error('cart change ' + r.status); })
      .catch(function () {})
      .then(function () {
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { noOpen: true } }));
        return refresh();
      })
      .then(function () { busy = false; });
  });
})();
